import React from "react";
import "./login.scss";
import {
  Form,
  Field,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import FormPasswordField from "../../components/formFields/FormPasswordField";
import {
  passwordValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import { useNavigate } from "react-router-dom";
import { employeeLogin } from "./loginSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import Logo from "../../assets/Images/logo.png";
import loginImg from "../../assets/Images/design-1.jpg"

const LogIn: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const loading = useAppSelector((state) => state.login.loading);

  const handleSubmit = async (values: any) => {
    const data = {
      UserName: values.UserName,
      Password: values.Password,
    };

    // edit by jyotindra
    const response = await dispatch(employeeLogin(data));
    if (response?.meta?.requestStatus === "fulfilled") {
      navigate("/");
    }
  };
  return (
    <div className="bg-img">
      <div className="content row display-flex overflow-hidden">
        <div className="d-none d-lg-flex col-lg-6 d-flex align-items-center justify-content-center overflow-hidden">
          <img src={loginImg} alt="Logo" style={{ height: "101%", width: "130%" }} />
        </div>
        <div className="col-lg-6 p-5">
          <img src={Logo} alt="Logo" style={{ maxWidth: 180 }} />
          <h4 className="text-light mt-4">Log In</h4>
          <Form
            onSubmit={handleSubmit}
            initialValues={{
              UserName: "",
              Password: "",
              RememberMe: false,
            }}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <Field
                  name={"UserName"}
                  type={"text"}
                  component={FormTextField}
                  label={"Username"}
                  maxLength="16"
                  placeholder="Enter Your Username"
                  validator={requiredValidator}
                  astrike={true}
                  labelClassName="text-light mb-2"
                  wrapperClassName="mb-4"
                  fieldClassName="bg-transparent border-white text-white"
                />
                <Field
                  name={"Password"}
                  type={"password"}
                  component={FormPasswordField}
                  label={"Password"}
                  maxLength="50"
                  astrike={true}
                  placeholder="Enter Your Password"
                  validator={passwordValidator}
                  wrapperClassName="mb-4"
                  labelClassName="text-light mb-2"
                  fieldClassName="bg-transparent border-white text-white"
                />
                <div
                  style={{
                    marginTop: 40,
                  }}
                >
                  <ButtonWithLoading
                    label="Login"
                    themeColor="primary"
                    type="submit"
                    width="100%"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                    className="login-btn"
                  />
                </div>
              </FormElement>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default LogIn;
